import { CellphoneRemoveIcon } from './CellphoneRemoveIcon';

/**
 * author: Michael Irigoyen
 * id EC642A5A-34A2-4E29-85F1-60ACAA546FB1
 * name cellphone-remove
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-remove.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const SmartphoneEraseIcon = CellphoneRemoveIcon;
export default SmartphoneEraseIcon